import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import { blogPosts, getBlogPosts } from './blogData';

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    setPosts(getBlogPosts());
    document.title = 'Blog - Celebrity Cuts | Hair & Beauty Tips';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Read the latest hair and beauty tips, trends, and styling advice from Celebrity Cuts salon experts in Visakhapatnam.');
    }
  }, []);

  return (
    <div className="blog-page">
      <div className="blog-container">
        <h1 className="blog-page-title">Celebrity Cuts Blog</h1>
        <p className="blog-page-subtitle">
          Expert tips, trends, and advice on hair, skin, and beauty
        </p>
        
        <div className="blog-grid">
          {posts.map((post) => (
            <Link to={`/blog/${post.slug}`} key={post.id} className="blog-card-link">
              <article className="blog-card">
                <div className="blog-card-image">
                  <img src={post.image} alt={post.title} />
                </div>
                <div className="blog-card-content">
                  <span className="blog-category">{post.category}</span>
                  <h2 className="blog-title">{post.title}</h2>
                  <p className="blog-excerpt">
                    {post.description}
                    <a href="https://celebritycuts.in/" target="_blank" rel="noopener noreferrer" className="blog-link">{post.descriptionWithLink}</a>
                    {post.descriptionAfterLink}
                  </p>
                  <div className="blog-meta">
                    <span className="blog-date">{post.date}</span>
                    <span className="blog-read-more">Read More →</span>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;


